const ConsentMapper = {
    map: [
        {
            type: 2,
            name: 'email',
            label: 'Zgoda na komunikację e-mail',
            description: 'Jako pierwszy dowiesz się o starcie najnowszej gazetki promocyjnej i ofert sezonowych. Otrzymasz informację o wydarzeniach i szkoleniach w Akademii Inspiracji i dostęp do rabatów tylko dla naszych subskrybentów.',
            input: {
                shortLabel: 'E-mail',
                longLabel: 'Podaj swój adres e-mail',
                type: 'email'
            }
        },
        {
            type: 4,
            name: 'phone',
            label: 'Zgoda na komunikację telefoniczną',
            description: 'Pozostawaj w kontakcie z personal care manager i dziel się z nami swoją opinią.',
            input: {
                shortLabel: 'Telefon',
                longLabel: 'Podaj swój numer telefonu',
                type: 'phone'
            }
        },
        {
            type: 6,
            name: 'sms',
            label: 'Zgoda na komunikację sms',
            description: 'Otrzymuj informacje o bardzo atrakcyjnych cenowo promocjach czasowych, które komunikujemy tylko kanałem SMS. Warto!',
            input: {
                shortLabel: 'Telefon',
                longLabel: 'Podaj swój numer telefonu',
                type: 'phone'
            }
        }
    ],

    getByType(type) {
        let out = this.map.filter(item => {
            return item.type === type
        })

        return out.length > 0 ? out[0] : null
    },

    getByName(name) {
        let out = this.map.filter(item => {
            return item.name === name
        })

        return out.length > 0 ? out[0] : null
    }
}

export default ConsentMapper